// ----------------------------------------------------------------------

const account = {
  displayName: 'Syed Mehdi',
  email: 'mehdiraza1232016@gmail.com',
  photoURL: '/akal/assets/images/avatars/avatar_default.jpg',
};

export default account;
